// the list of attributes contains a value "all" with id 0.
// We don't show this because we have our own reset button
export const RESET_ATTRIBUTE_ID = '0';

export const RUBRIK_ATTRIBUTE_ID = '10';
export const THEMA_ATTRIBUTE_ID = '15';
export const ARBEITSORT_ATTRIBUTE_ID = '20';
export const ABTEILUNG_ATTRIBUTE_ID = '30';
export const STELLART_ATTRIBUTE_ID = '50';
export const HOMEOFFICE_ATTRIBUTE_ID = '60';
export const BEFRISTUNG_ATTRIBUTE_ID = '70';
export const HIERARCHY_ATTRIBUTE_ID = 'hk_id';

export const JOBS_MAX_LIMIT = 200; // this is also enforced by the backend, no matter what we set here
export const INITIAL_PAGE_SIZE = 10;
